import kebabCase from 'lodash/kebabCase';
import React from 'react';
import { Box } from '../../Box/Box';
import { Link } from '../../Link/Link';
const scrollTo = id => document.getElementById(id)?.scrollIntoView({
  behavior: 'smooth'
});
/**
 * @public
 */
export const TableOfContents = ({
  links
}) => React.createElement(Box, {
  my: 5
}, React.createElement("ul", null, links.map(link => {
  const id = kebabCase(link);
  return React.createElement(Link, {
    key: id,
    onClick: () => scrollTo(id)
  }, React.createElement("li", null, link));
})));